import React, { useEffect, useState } from 'react';
import Image, { ImageProps }          from 'next/image'
import { BLUR_DATA }                  from '@utils/network-utils';
import { Paper }                      from '@mantine/core';
import placeHolderImage               from '../../../public/images/placeholder-600x300.jpg'


interface Props extends ImageProps {
    fallbackSrc?: string;
    alt?: string;
    onClick?: () => void;
}

export const DXBImageView: React.FC<Props> = (props) => {

    // const { classes } = useStyles();

    const {
        src: _src,
        fallbackSrc,
        alt, onClick,
        className,
        ...rest
    } = props;

    const [imgSrc, setImgSrc] = useState(_src);

    useEffect(() => {
        setImgSrc(_src);
    }, []);

    const url = _src === undefined || _src === null ? placeHolderImage : imgSrc;

    // const [isLoading, setIsLoading] = useState(true);

    return (
        <Paper>
            {/*{isLoading && <Loader color="#f39c12" variant="dots" size="sm"/>}*/}
            <Image
                {...rest}
                className={className}
                placeholder="blur"
                blurDataURL={BLUR_DATA}
                src={url}
                alt={alt}
                onLoadingComplete={(result) => {

                    // setIsLoading(false);

                    if (result.naturalWidth === 0) {
                        setImgSrc(fallbackSrc || placeHolderImage);
                    }
                }}
                onError={() => {
                    setImgSrc(fallbackSrc || placeHolderImage);
                }}
                onClick={onClick}
                layout="responsive"
                objectFit="cover"
            />
        </Paper>
    );

}
